import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

const MAX_PERCENT = 100;

@Component({
  selector: 'prlw-table-volume-progress-bar',
  templateUrl: './volume-progress-bar.container.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VolumeProgressBarContainer {
  @Input() public current!: number;
  @Input() public forecast!: number;

  public get progressData(): number[] {
    if (!this.current || !this.forecast) {
      return [0];
    }
    const forecast = this.forecast || 1;
    const whole = Math.floor(this.current / forecast);
    const percent = Math.floor(
      ((this.current - forecast * whole) / forecast) * MAX_PERCENT,
    );
    return [...Array(whole).fill(MAX_PERCENT), percent].filter(Boolean);
  }
}
